import {useState,useEffect,useRef} from 'react';
import {authservices} from '../../services/authServices';
import {userservices} from '../../services/userServices';
import { Toast } from 'primereact/toast';
import { Backbuttons } from '../../components/buttons';
import  Bredcrum  from '../../components/bredcrum';


const Adduser = () => {
    const [initialvalues,setValues] = useState(
        {
            'name':'',
            'email':'',
            'roles':'',
            'usertype':''
        }
    );
    const [initialroles,setRoles] = useState([]);
    const toast = useRef(null);

  
    useEffect(()=>{
        getRoles();
    },[])  

    const handleChanges = (e) =>{
       setValues((prevdata)=>{
            return {
                ...prevdata,
                [e.target.name]:e.target.value  
            } 
       });  
    }

    const adduser = (e)=>{
        e.preventDefault();
        console.log(initialvalues);   
        let userdata = initialvalues; 
        userservices.adduser(userdata).then((response)=>{
            // console.log(response);
           if(response.status == 200){
            //   console.log("response data");   
            //   console.log(response); 
              toast.current.show({ severity: 'success', summary: 'Users', detail: 'User added Successfully' }); 
           }else{
              toast.current.show({ severity: 'error', summary: 'Users', detail: response.data.data });      
           }      
        }).catch((error)=>{
            console.log(error);
            toast.current.show({ severity: 'error', summary: 'Users', detail: 'Error' });  
        });  
    }

    const getRoles = () =>{
        authservices.getroles().then((response)=>{
            if(response.status == 200){
                // let arraydata= JSON.parse(response.data);
                setRoles(response.data.data);
            }else{
                setRoles([]); 
            }      
         }).catch((error)=>{
              setRoles([]);
         });   
         
    }

    const displayRoles = () =>{
        let dataobj = []; 
        // console.log(initialroles);
        initialroles.forEach((value)=>{    
            // console.log(value.name);
            dataobj.push(<option value={value.id}>{value.name}</option>);     
        });
        return dataobj;
    }
     
   
    
    return (
        <>
          <Toast ref={toast} /> 
           <Bredcrum title={'Create User'} divider={false}/>
           <div className="card ps-3 pe-4 pt-3 pb-3">
           <form onSubmit={(e)=>adduser(e)}>
            <div class="row">
                <div className="col-md-6"> 
                 <div class="form-group">
                    <label for="name">Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        placeholder="Enter name"
                        onChange={handleChanges}
                    />
                 </div>
                </div>
                <div className="col-md-6"> 
                    <div class="form-group">
                        <label for="email2">Email Address</label>
                        <input
                            type="email"
                            class="form-control"
                            id="email2"
                            name="email"
                            placeholder="Enter Email"
                            onChange={handleChanges}
                        />
                    </div>
                </div>

                <div className="col-md-6"> 
                    <div class="form-group">
                        <label for="email2">Select Role</label>
                        <select className="form-control" required name="roles" onChange={handleChanges}>
                            <option value="">Select Role</option>
                            {displayRoles()}
                            {/* <option value="superadmin">Superadmin</option>
                            <option value="admin">Admin</option>
                            <option value="user">User</option> */}
                        </select>
                    </div>
                </div>

                <div className="col-md-6"> 
                    <div class="form-group">
                        <label for="email2">Select User Type</label>
                        <select className="form-control" required name="usertype" onChange={handleChanges}>
                            <option value="">User Type</option>
                            <option value="internal">Internal User</option>
                            <option value="external">External User</option>
                            {/* <option value="superadmin">Superadmin</option>
                            <option value="admin">Admin</option>
                            <option value="user">User</option> */}
                        </select>
                    </div>
                </div>

                <div className="col-md-6">
                   <div class="form-group">
                      <button
                            type="submit"
                            className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                        >
                            Save
                        </button>
                   </div>
                  
                </div>
                
             </div>
             </form>
             </div>
        </>
    );
}

export default Adduser;